import { PROYECT } from "services/api"
import { setSnackbar, startRequest, startRequestComp, stopRequest, stopRequestComp } from "../search/searchActions"
import { api_get } from "services/api"
import { GET_CONDITIONS } from "redux/reducers/conditionsCatalog/conditioinsReducer"
import { api_post } from "services/api"
import { NEW_CONDITION } from "redux/reducers/conditionsCatalog/conditioinsReducer"
import { MOD_CONDITION } from "redux/reducers/conditionsCatalog/conditioinsReducer"
import { DEL_CONDITION } from "redux/reducers/conditionsCatalog/conditioinsReducer"
import { api_delete } from "services/api"
import { api_put } from "services/api"

const mainUrl = `${process.env.REACT_APP_URL}${PROYECT}`

export const getConditions = () => {
  const url = `${mainUrl}/comercial-conditions`
  return async dispatch => {
    dispatch(startRequest())
    await api_get(url).then(resp => {
      dispatch({
        type: GET_CONDITIONS,
        payload: resp
      })
    }).catch(err => {
      dispatch( setSnackbar('Error al cargar las condiciones') )
    })
    dispatch( stopRequest() )
  }  
}

export const newContidion = (form) => {
  const url = `${mainUrl}/comercial-conditions`
  return async dispatch => {
    dispatch(startRequestComp())
    await api_post(url, form).then(resp => {
      const newResp = {
        ...resp,
        label: resp.name,
        value: resp.id
      }
      dispatch({
        type: NEW_CONDITION,
        payload: newResp
      })
      dispatch(stopRequestComp())
      dispatch( setSnackbar('Nueva condición agregada', 'success') )
    }).catch(err => {
      dispatch( setSnackbar('Error al agregar la condición') )
    })
  }  
}

export const editCondition = ( id, form ) => {
  const url = `${mainUrl}/comercial-conditions/${id}`
  return async dispatch => {
    dispatch(startRequestComp())
    await api_put(url, form).then(resp => {
      dispatch({
        type: MOD_CONDITION,
        payload: resp
      })
      dispatch(stopRequestComp())

      dispatch( setSnackbar('Edición realizada', 'success') )
    }).catch(err => {
      dispatch( setSnackbar(`Error al editar la condición: ${id}`) )
    })
  }  
}

export const deleteContidion = ( id ) => {
  const url = `${mainUrl}/comercial-conditions/${id}`
  return async dispatch => {
    dispatch(startRequestComp())
    await api_delete(url).then(resp => {
      dispatch({
        type: DEL_CONDITION,
        payload: id
      })
      dispatch(stopRequestComp())
      dispatch( setSnackbar('Condición eliminada', 'success') )
    }).catch(err => {
      dispatch( setSnackbar('Error al editar la condición: ${id}') )
    })
  }  
}

